import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=0dfaba96&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"
import style0 from "./Info.vue?vue&type=style&index=0&id=0dfaba96&lang=stylus&scoped=true&"
import style1 from "./Info.vue?vue&type=style&index=1&id=0dfaba96&lang=stylus&scoped=true&"
import style2 from "./Info.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfaba96",
  null
  
)

export default component.exports